/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Toast_Create_ErrorInputs */

const en_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const de_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const fr_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const es_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const it_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const nl_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const pl_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const fi_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const da_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

const sv_story_bank_toast_create_error = /** @type {(inputs: Story_Bank_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create story`)
};

/**
* | output |
* | --- |
* | "Failed to create story" |
*
* @param {Story_Bank_Toast_Create_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_toast_create_error = /** @type {((inputs?: Story_Bank_Toast_Create_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Toast_Create_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_toast_create_error(inputs)
	if (locale === "fr") return fr_story_bank_toast_create_error(inputs)
	if (locale === "es") return es_story_bank_toast_create_error(inputs)
	if (locale === "it") return it_story_bank_toast_create_error(inputs)
	if (locale === "nl") return nl_story_bank_toast_create_error(inputs)
	if (locale === "pl") return pl_story_bank_toast_create_error(inputs)
	if (locale === "fi") return fi_story_bank_toast_create_error(inputs)
	if (locale === "da") return da_story_bank_toast_create_error(inputs)
	if (locale === "sv") return sv_story_bank_toast_create_error(inputs)
	return en_story_bank_toast_create_error(inputs)
});